import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withPrefix } from 'gatsby';
import { useFormik } from 'formik';
import slugify from 'slugify';
import nookies from 'nookies';

import { useMouseOut } from '../utils/useMouseOut';

import Timer from './timer';
import Button from './button';
import InputCheckbox from './inputCheckbox';
import InputToggleButton from './inputToggleButton';
import Answers from './answers';
import Popup from './popup';

import { popupUnfinishedSeen } from '../state/app/actions';
import { quizAnswer, quizNext } from '../state/quiz/actions';

import quizData from '../../content/quiz.json';

const Questions = ({ popupSeen, questionIndex, question, questionsNumber, error, setPopupSeen, setAnswer, nextQuestion }) => {
  const [popup, setPopup] = useState(false);
  const questionRef = useRef(null);

  const showPopup = () => {
    if (!popupSeen) {
      setPopup(true);
    }
  };

  const hidePopup = () => {
    setPopup(false);
    setPopupSeen();
  };

  useMouseOut({ onlyTop: true }, showPopup);

  useEffect(() => {
    const myConfirmation = e => {
      const message = 'Nie odpowiedziałeś jeszcze na wszystkie pytania. Czy na pewno chcesz zakończyć Test?';
      e.returnValue = message;
      return message;
    };

    window.onbeforeunload = myConfirmation;

    return () => {
      window.onbeforeunload = undefined;
    };
  });

  useLayoutEffect(() => {
    setTimeout(() => {
      if (questionRef.current) {
        questionRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300);
  }, [question.id]);

  return (
    <div ref={questionRef} className="question">
      <div className="question__timer">
        <Timer />
      </div>
      <div className="question__content">
        <div className="question__number">
          Pytanie {questionIndex} z {questionsNumber}
        </div>
        <div className="question__text">{question.question}</div>
        <div className="question__answers">
          <Answers question={question} onAnswer={setAnswer} />
        </div>
        <div className="question__image question__image--mobile">{!!question.image && <img src={withPrefix(question.image)} />}</div>
        <div className="question__error">{error}</div>
        <Button onClick={() => nextQuestion()} type="button" mobile>
          Następne pytanie
        </Button>
      </div>
      <div className="question__image question__image--desktop">{!!question.image && <img src={withPrefix(question.image)} />}</div>

      {popup && (
        <Popup onClose={hidePopup}>
          <div className="popup__title">Odpowiedz na wszystkie pytania.</div>
          <div className="popup__text">Nadal masz szansę zakończyć Test Wiedzy Ekonomicznej z pozytywnym wynikiem.</div>
          <div className="popup__buttons">
            <button type="button" className="button" onClick={hidePopup}>
              Chcę odpowiedzieć na pozostałe pytania
            </button>
          </div>
        </Popup>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    popupSeen: state.root.app.popupUnfinishedSeen,
    questionIndex: state.root.quiz.questionIndex + 1,
    question: state.root.quiz.question,
    questionsNumber: state.root.quiz.questions.length,
    error: state.root.quiz.error,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPopupSeen: () => dispatch(popupUnfinishedSeen()),
    setAnswer: answer => dispatch(quizAnswer({ answer })),
    nextQuestion: () => dispatch(quizNext()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Questions);
